"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author tatevik.marikyan
 * @author Vahagn Lazyan
 * @since 22/09/2017
 */
var operators_1 = require("rxjs/operators");
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_authorization_client_js_1 = require("@synisys/idm-authorization-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var data_service_1 = require("../../api/service/data.service");
var de_permission_model_1 = require("../model/de-permission.model");
var from_1 = require("rxjs/observable/from");
var zip_1 = require("rxjs/observable/zip");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var HttpDePermissionService = /** @class */ (function () {
    /*tslint:enable:max-line-length*/
    function HttpDePermissionService(_applicationPropertiesService, _authenticationService, _authorizationService, _dataService) {
        this._applicationPropertiesService = _applicationPropertiesService;
        this._authenticationService = _authenticationService;
        this._authorizationService = _authorizationService;
        this._dataService = _dataService;
        this.DE_SERVICE_URI_KEY = 'de-service-url';
        /*tslint:disable:max-line-length*/
        this.URL_ENTITY_PERMISSIONS_BY_INSTANCE_ID = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/entity/permission/", "/instance/", "/", ""], ["", "/entity/permission/", "/instance/", "/", ""])), 'serviceUri', 'systemName', 'entityInstanceId', 'userId');
        this.URL_ENTITIES_PERMISSIONS_BY_INSTANCE_IDS = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", "/entities/permission/", "/", ""], ["", "/entities/permission/", "/", ""])), 'serviceUri', 'systemName', 'userId');
    }
    /**
     * Get deserialized de permission for specified category by Entity Instance Id
     * @param {string} systemName - category system name.
     * @param {number} entityInstanceId
     * @returns {Observable<DePermission>}
     */
    HttpDePermissionService.prototype.getCategoryDePermissionsByInstance = function (systemName, entityInstanceId) {
        var dePermissionObservable = this.loadDePermissions(systemName, entityInstanceId);
        return this.deserializeDePermissions(dePermissionObservable);
    };
    HttpDePermissionService.prototype.getCategoryDePermissionsByInstances = function (systemName, entitiesInstanceIds) {
        var dePermissionsObservable = this.loadDePermissionsBulk(systemName, entitiesInstanceIds);
        return this.deserializeDePermissionsBulk(dePermissionsObservable);
    };
    /**
     * Checking Create / Add permission by Category
     * @param {string} systemName
     * @returns {Observable<boolean>}
     */
    HttpDePermissionService.prototype.hasCreatePermissionByCategory = function (systemName) {
        return this.getPermissionValue(systemName, idm_authorization_client_js_1.PermissionType.ADD).pipe(operators_1.map(function (categoryPermissionValues) {
            if (categoryPermissionValues.size > 0) {
                return Array.from(categoryPermissionValues).some(function (categoryPermissionValue) {
                    return (categoryPermissionValue.access !== idm_authorization_client_js_1.Access.DENIED);
                });
            }
            else {
                return false;
            }
        }));
    };
    /**
     * Indicates if has access to specified Category Type
     * @param {string} systemName - category system name
     * @param {PermissionType} permissionType - requested permission type
     * @param {number} [workflowStateId] workflow state id
     * @returns {Observable<boolean>}
     * * @deprecated Use instead getCategoryDePermissionsByInstance
     */
    HttpDePermissionService.prototype.hasAccessByPermissionType = function (systemName, permissionType, workflowStateId) {
        if (workflowStateId === void 0) { workflowStateId = null; }
        return this.getPermissionValue(systemName, permissionType, workflowStateId).pipe(operators_1.map(function (permissions) {
            return Array.from(permissions).some(function (permission) {
                return permission.access !== idm_authorization_client_js_1.Access.DENIED;
            });
        }));
    };
    /**
     * Gets the Permission based on Category Permission Type and User Data
     * @param {string} systemName
     * @param {PermissionType} permissionType
     * @param {number} workflowStateId  workflow state id
     * @returns {Observable<PermissionValueDto>}
     */
    HttpDePermissionService.prototype.getPermissionValue = function (systemName, permissionType, workflowStateId) {
        var _this = this;
        var userData$ = this._authenticationService.getUserData();
        return userData$.pipe(operators_1.switchMap(function (userData) {
            var categoryPermissionRequestDataDto = {
                categorySystemNames: [systemName],
                conditionalPermissionValues: {},
                permissionType: permissionType,
                userId: userData.userId,
                workflowStateId: null,
            };
            return _this._authorizationService
                .getCategoryPermissionsValues(categoryPermissionRequestDataDto)
                .pipe(operators_1.map(function (permissions) {
                return permissions.get(systemName);
            }));
        }));
    };
    /**
     * Loads de permission for specified category by Entity Instance Id
     * @param {string} systemName
     * @param {number} entityInstanceId
     * @returns {Observable<any>}
     */
    HttpDePermissionService.prototype.loadDePermissions = function (systemName, entityInstanceId) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(systemName);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(entityInstanceId);
        var applicationProperties$ = from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY));
        var userData$ = this._authenticationService.getUserData();
        return zip_1.zip(userData$, applicationProperties$).pipe(operators_1.switchMap(function (data) {
            var userData = data[0];
            var serviceUri = data[1];
            var url = _this.URL_ENTITY_PERMISSIONS_BY_INSTANCE_ID.replaceTemplate({
                entityInstanceId: (entityInstanceId || '')
                    .toString()
                    .split('?')[0],
                serviceUri: serviceUri,
                systemName: systemName,
                userId: userData.userId.toString(),
            });
            return _this._dataService.load(url);
        }));
    };
    HttpDePermissionService.prototype.loadDePermissionsBulk = function (systemName, entityInstanceIds) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(systemName);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(entityInstanceIds);
        var applicationProperties$ = from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY));
        var userData$ = this._authenticationService.getUserData();
        var queryParams;
        return zip_1.zip(userData$, applicationProperties$).pipe(operators_1.switchMap(function (data) {
            var userData = data[0];
            var serviceUri = data[1];
            queryParams = [];
            queryParams.push(new idm_de_core_frontend_1.SearchParam('ids', entityInstanceIds.toString()));
            var url = _this.URL_ENTITIES_PERMISSIONS_BY_INSTANCE_IDS.replaceTemplate({
                serviceUri: serviceUri,
                systemName: systemName,
                userId: userData.userId.toString(),
            });
            return _this._dataService.load(url, queryParams);
        }));
    };
    /**
     * Deserializes De Permissions
     * @param {Observable<any>} dePermissions$
     * @returns {Observable<DePermission>}
     */
    HttpDePermissionService.prototype.deserializeDePermissions = function (dePermissions$) {
        return dePermissions$.pipe(operators_1.map(function (permissionData) {
            var canCreate = permissionData.add && permissionData.add.permission;
            var canDelete = permissionData.delete && permissionData.delete.permission;
            return new de_permission_model_1.DePermission(canCreate, canDelete, permissionData.view, permissionData.edit, permissionData.add);
        }));
    };
    /**
     * Deserializes De Permissions
     * @param {Observable<any>} dePermissions$
     * @returns {Observable<DePermission>}
     */
    HttpDePermissionService.prototype.deserializeDePermissionsBulk = function (dePermissions$) {
        return dePermissions$.pipe(operators_1.map(function (permissionsData) {
            return permissionsData.map(function (permissionData) {
                var canCreate = permissionData.add && permissionData.add.permission;
                var canDelete = permissionData.delete &&
                    permissionData.delete.permission;
                return new de_permission_model_1.DePermission(canCreate, canDelete, permissionData.view, permissionData.edit);
            });
        }));
    };
    HttpDePermissionService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_authentication_client_js_1.AuthenticationService,
            idm_authorization_client_js_1.AuthorizationService,
            data_service_1.DataService])
    ], HttpDePermissionService);
    return HttpDePermissionService;
}());
exports.HttpDePermissionService = HttpDePermissionService;
var templateObject_1, templateObject_2;
//# sourceMappingURL=http-de-permission.service.js.map